import internalApi from "./internalApi"

// Vague Vision : réglages persistés côté serveur (admin-service).
export async function getConfigActive() {
  try { const r = await internalApi.get('/config/active'); return r.data; }
  catch (e) { console.log(e); return null; }
}
export async function majVisionConfig(payload: any) {
  try { const r = await internalApi.put('/config/vision', payload); return r.data; }
  catch (e) { console.log(e); return { erreur: true }; }
}
// Vague 2 : réglages d'intégrité de la capture (admin-service).
export async function majIntegriteConfig(payload: any) {
  try { const r = await internalApi.put('/config/integrite', payload); return r.data; }
  catch (e) { console.log(e); return { erreur: true }; }
}
export async function getIntegriteChangements() {
  try { const r = await internalApi.get('/config/integrite/changements'); return r.data; }
  catch (e) { console.log(e); return []; }
}

/* Ces fonctions laissent remonter l'erreur axios (Z7-39) : renvoyer l'erreur
   comme une valeur faisait passer un refus (400, 403) pour un succès, et
   « Admin créé avec succès » s'affichait même en cas d'échec. */

/** Création d'un admin (SUPER_ADMIN) : un des trois rôles fixes dans `role`.
    Le serveur génère le mot de passe temporaire et l'envoie par email. */
export async function createAdmin(data: any) {
  const response = await internalApi.post('/admin', data);
  return response.data;
}

export async function signInUser(data: any) {
  try {
    const response = await internalApi.post('/admin/sign-in', data)
    return response.status === 200 ? response.data : null
  } catch (error) {
    return null
  }
}

  /* Fiche et droits de l'administrateur connecté. L'erreur remonte : chaque
     écran dit que ses droits sont illisibles au lieu de lire un objet erreur. */
  export async function getUser() {
    const response = await internalApi.get('/admin')
    return response.data
  }

export async function getRole() {
  const response = await internalApi.get('/roles');
  return response.data;
}

export async function getRoleById(id: any) {
  const response = await internalApi.get(`/roles/${id}`);
  return response.data;
}

/* Administration des comptes du back-office (SUPER_ADMIN, imposé par le serveur). */
export async function listerAdmins() {
  const r = await internalApi.get('/sa/admins');
  return Array.isArray(r.data) ? r.data : [];
}
/** Prénom, nom, domaine ; le rôle n'est retenu que pour un autre compte, par un SUPER_ADMIN. */
export async function majAdmin(id: number, data: any) {
  const r = await internalApi.put(`/admin/update/${id}`, data);
  return r.data;
}
/** Son propre profil (permis au VIEWER) : le serveur ignore le rôle. */
export async function majMonProfil(id: number, data: { first_name: string; last_name: string; domain: string }) {
  const r = await internalApi.put(`/admin/${id}`, data);
  return r.data;
}
export async function changerMonMotDePasse(id: number, ancien: string, nouveau: string) {
  const r = await internalApi.put(`/admin/${id}/mot-de-passe`, { ancien, nouveau });
  return r.data;
}
export async function revoquerAdmin(id: number) {
  const r = await internalApi.put(`/admin/${id}/revoquer`);
  return r.data;
}
export async function reactiverAdmin(id: number) {
  const r = await internalApi.put(`/admin/${id}/reactiver`);
  return r.data;
}
export async function supprimerAdmin(id: number) {
  const r = await internalApi.delete(`/admin/${id}`);
  return r.data;
}
/** Comptes de l'application (user_master) : Spotters, clients, compteurs. */
export async function getStatsComptes() {
  const r = await internalApi.get('/sa/stats');
  return r.data;
}
export async function getComptesSpotters() {
  const r = await internalApi.get('/sa/collecteurs');
  return Array.isArray(r.data) ? r.data : [];
}
export async function getComptesClients() {
  const r = await internalApi.get('/sa/clients');
  return Array.isArray(r.data) ? r.data : [];
}

// Réglages d'argent (décisions D1 et D2) : valeur du Tip et règles de retrait.
// Modifiables par un SUPER_ADMIN uniquement, motif obligatoire, journalisés.
// L'erreur remonte à l'appelant (400 motif ou valeurs, 403 rôle).
export async function majReglagesArgent(payload: any) {
  const r = await internalApi.put('/config/argent', payload);
  return r.data;
}
export async function getChangementsArgent() {
  try { const r = await internalApi.get('/config/argent/changements'); return Array.isArray(r.data) ? r.data : []; }
  catch (e) { console.log(e); return []; }
}

// Facturation (décision D10) : entités émettrices et archive des documents.
export async function getEntitesFacturation() {
  try { const r = await internalApi.get('/facturation/entites'); return Array.isArray(r.data) ? r.data : []; }
  catch (e) { console.log(e); return []; }
}
export async function majEntiteFacturation(pays: string, payload: any) {
  const r = await internalApi.put(`/facturation/entites/${pays}`, payload);
  return r.data;
}
export async function getDocumentsEmis() {
  try { const r = await internalApi.get('/facturation/documents'); return Array.isArray(r.data) ? r.data : []; }
  catch (e) { console.log(e); return []; }
}
export async function telechargerDocumentEmis(id: number, numero: string) {
  const r = await internalApi.get(`/facturation/documents/${id}/pdf`, { responseType: 'blob' });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement('a'); a.href = url; a.download = `${numero}.pdf`; a.click();
  URL.revokeObjectURL(url);
}
